// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as filters from './filters';
import * as directives from './directives';
import i18n from './lang/lang';
import store from './stores/index'

// plugin
import VueCookie from 'vue-cookies';
import {ValidationProvider, ValidationObserver, extend, localize, setInteractionMode} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

// import common prototype
import Constant from './configs/constant';
import Helper from './helpers/index';
import './helpers/validate';
import Api from './services/api'
import Moment from 'moment'
import ModalSuccess from '@/components/commons/ModalSuccess';
import Breadcrumb from '@/components/commons/Breadcrumb';
import ModalError from '@/components/commons/ModalError';

import eventBus from '@/services/eventBus';

import VueGtag from 'vue-gtag';
import Vue2TouchEvents from 'vue2-touch-events'
import TextareaAutosize from 'vue-textarea-autosize'
import Datepicker from 'vuejs-datepicker';

Vue.prototype.$constant = Constant
Vue.prototype.$helper = Helper
Vue.prototype.$api = Api
Vue.prototype.$moment = Moment
Vue.prototype.$cookie = VueCookie
Vue.prototype.$eventBus = eventBus
setInteractionMode('passive');

i18n.locale = VueCookie.get('locale') || 'ja';
Moment.locale(i18n.locale);
localize(i18n.locale)
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

if (Constant.GOOGLE_TAG_ID) {
  Vue.use(VueGtag, {
    config: {id: Constant.GOOGLE_TAG_ID},
    pageTrackerTemplate (to) {
      let path = to.path
      if (Object.keys(to.query).length) {
        try {
          let query = Object.keys(to.query).map(function (key) {
            return encodeURIComponent(key) + '=' +
              encodeURIComponent(to.query[key]);
          }).join('&')
          path += '?' + query
        } catch (e) {
          console.log(e)
        }
      }
      return {
        page_title: to.name, // route name value
        page_path: path, // route path value
        page_location: window.location.href
      }
    }
  }, router);
}
Vue.use(Vue2TouchEvents)
Vue.use(TextareaAutosize)

Vue.config.productionTip = false
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('modal-success', ModalSuccess);
Vue.component('breadcrumb', Breadcrumb);
Vue.component('modal-error', ModalError);
Vue.component('date-picker', Datepicker);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js